import Storage from "../services/storage-service/Storage";

export default class ManagerApiFeatureFlag {
    static getNewManagerApiStorageConfig = () => {
        const storage = Storage.get("new-manager-api");
        if (storage && typeof storage === "string") {
            return { ["X-New-Manager-Api"]: storage };
        }
        return undefined;
    };
}
